<template>
  <div class="period-chooser">
    <label class="period-chooser__label">
      <span class="period-chooser__label-text">{{ $t('message.calculatingPeriod') }}</span>
      <span class="period-chooser__value">
        <span class="period-chooser__value-sup">{{ $tc('plural.day', value)}}</span>
      </span>
    </label>
    <b-form-input :max="max" :min="min" :value="value" @input="onChange($event)" type="range"/>
  </div>
</template>

<script>
  import declOfNum from "../../mixins/declOfNum";

  export default {
    name: "PeriodChooser",
    model: {
      prop: 'value',
      event: 'change'
    },
    mixins: [declOfNum],
    props: {
      value: {
        type: Number,
        default: 1
      },
      min: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
        default: Infinity
      }
    },
    filters: {
      num(n) {
        return parseInt(n);
      }
    },
    methods: {
      onChange(value) {
        this.$emit('change', parseInt(value));
      }
    },
  }
</script>

<style scoped>
  .period-chooser {
    margin: 2em 0;
  }

  .period-chooser__label {
    display: flex;
    align-items: flex-end;
    align-content: space-between;
  }

  .period-chooser__label-text {
    margin-right: auto;
  }

  .period-chooser__value {
    text-align: right;
  }

  .period-chooser__value-sup {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 32px;
  }

  /*.period-chooser__value-sub {*/
  /*  font-style: normal;*/
  /*  font-weight: normal;*/
  /*  font-size: 12px;*/
  /*  line-height: 24px;*/
  /*}*/
</style>
